////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
///////COMPONENTS///////
import ModalDelete from '../ModalDelete/ModalDelete'
import ModalUnactive from '../ModalUnactive/ModalUnactive'
import ModalActive from '../ModalActive/ModalActive'
import ModalDeleteStopDeposit from '../ModalDeleteStopDeposit/ModalDeleteStopDeposit'
import ModalDeleteAddStartWithDeposit from '../ModalDeleteAddStartWithDeposit/ModalDeleteAddStartWithDeposit'
import ModifyAddStartWithDepositAction from '../DatePicker/ModifyAddStartWithDepositAction/ModifyAddStartWithDepositAction'
import AddStopDeposit from '../DatePicker/AddStopDeposit/AddStopDeposit'
import ModifyStopDeposit from '../DatePicker/ModifyStopDeposit/ModifyStopDeposit'
import ModalDeleteScheduledActivate from '../ModalDeleteScheduledActivate/ModalDeleteScheduledActivate'
import AddStartWithDepositAction from '../DatePicker/AddStartWithDeposit/AddStartWithDeposit'
import ScheduledActivateAction from '../DatePicker/ScheduledActivateAction/ScheduledActivateAction'
import ModalModifyScheduledActivateAction from '../DatePicker/ModalModifyScheduledActivateAction/ModalModifyScheduledActivateAction'
import ModalScheduleDeactivateAction from '../ModalScheduleDeactivateAction/ModalScheduleDeactivateAction'
import ModalDeleteStopWithRestockAction from '../ModalDeleteStopWithRestockAction/ModalDeleteStopWithRestockAction'
import ModalCancelDeactivateAction from '../ModalCancelDeactivateAction/ModalCancelDeactivateAction'
import ModalDeleteDeactivationAction from '../ModalDeleteDeactivationAction/ModalDeleteDeactivationAction'
import AddStopWithRestock from '../DatePicker/AddStopWithRestock/AddStopWithRestock'
import EditStopWithRestock from '../DatePicker/EditStopWithRestock/EditStopWithRestock'

/////////STYLED/////////
const ModalsContainerWrapper = styled.div``
/////////STYLED/////////

const ModalsContainer = (props) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalsContainerWrapper>
			{/* [63] components */}
			{/* [63]_a): INSTANT DESACTIVE */}
			<ModalUnactive unactive={{ ...props.unactive }} />
			{/* [63]_b): DELETE ITEM */}
			<ModalDelete delete={{ ...props.delete }} />
			{/* [63]_c): ADD STOP DEPOSIT */}
			<AddStopDeposit addStopDeposit={{ ...props.addStopDeposit }} />
			{/* [63]_d): MODIFY STOP DEPOSIT */}
			<ModifyStopDeposit modifyStopDeposit={{ ...props.modifyStopDeposit }} />
			{/* [63]_e): DELETE STOP DEPOSIT */}
			<ModalDeleteStopDeposit deleteStopDeposit={{ ...props.deleteStopDeposit }} />
			{/* [63]_f): ADD START DEPOSIT */}
			<AddStartWithDepositAction addStartWithDepositAction={{ ...props.addStartWithDepositAction }} />
			{/* [63]_g): MODIFY ADD START DEPOSIT */}
			<ModifyAddStartWithDepositAction action={{ ...props.modifyAddStartWithDepositAction }} />
			{/* [63]_h): DELETE ADD START DEPOSIT */}
			<ModalDeleteAddStartWithDeposit deleteAddStartWithDeposit={{ ...props.deleteAddStartWithDeposit }} />
			{/* [63]_i): ACTIVATE ITEM */}
			<ModalActive active={{ ...props.active }} />
			{/* [63]_j): SCHEDULED ACTIVATION ITEM  */}
			<ScheduledActivateAction scheduledActivateAction={{ ...props.scheduledActivateAction }} />
			{/* [63]_k): MODIFY SCHEDULED ACTIVATION ITEM  */}
			<ModalModifyScheduledActivateAction action={{ ...props.modifyScheduledActivateAction }} />
			{/* [63]_l): DELETE SCHEDULED ACTIVATION ITEM  */}
			<ModalDeleteScheduledActivate deleteScheduledActivate={{ ...props.deleteScheduledActivate }} />
			{/* [88] components */}
			{/* [88]_a): LAUNCH PROGRESSIVE DESACTIVATION */}
			<ModalScheduleDeactivateAction scheduleDeactivateAction={{ ...props.scheduleDeactivateAction }}></ModalScheduleDeactivateAction>
			{/* [88]_b): MODIFY PROGRESSIVE DESACTIVATION */}
			<ModalScheduleDeactivateAction scheduleDeactivateAction={{ ...props.editDeactivationAction }} updateMode></ModalScheduleDeactivateAction>
			{/* [88]_c): DELETE PROGRESSIVE DESACTIVATION */}
			<ModalDeleteDeactivationAction deleteDeactivationAction={{ ...props.deleteDeactivationAction }}></ModalDeleteDeactivationAction>
			{/* [88]_d): CANCEL PROGRESSIVE DESACTIVATION */}
			<ModalCancelDeactivateAction cancelDeactivateAction={{ ...props.cancelDeactivationAction }}></ModalCancelDeactivateAction>
			{/* [88]_e): ADD DATE STOP RESTOCK	 */}
			<AddStopWithRestock addStopWithRestockAction={{ ...props.addStopWithRestockAction }}></AddStopWithRestock>
			{/* [88]_f: MODIFY DATE STOP RESTOCK */}
			<EditStopWithRestock editStopWithRestockAction={{ ...props.editStopWithRestockAction }}></EditStopWithRestock>
			{/* [88]_g: DELETE DATE STOP RESTOCK */}
			<ModalDeleteStopWithRestockAction
				deleteStopWithRestockAction={{ ...props.deleteStopWithRestockAction }}
			></ModalDeleteStopWithRestockAction>
		</ModalsContainerWrapper>
	)
}

ModalsContainer.propTypes = {}

ModalsContainer.defaultPropTypes = {}

export default ModalsContainer
